import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted } from 'vue'
    import { useRoute } from '@common/composables'
    import { useAdminActiveSharesPage } from '@DataSharing/Shares/pages-core'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AdminActiveSharesPage',
  setup(__props) {

    document.title = 'Shares'

    const tid = useRoute().params.tid

    const { useActiveSharesQuery } = useAdminActiveSharesPage()

    const { modelActiveSharesQueryV1, runActiveSharesQueryV1 } = useActiveSharesQuery(parseInt(tid))

    const shares = computed(() => modelActiveSharesQueryV1.value?.Shares || [])

    onMounted(() => runActiveSharesQueryV1())

return { __sfc: true,tid, useActiveSharesQuery, modelActiveSharesQueryV1, runActiveSharesQueryV1, shares }
}

})